import { createBrowserRouter, Navigate } from 'react-router';
import { RequireAuth } from '@/components/auth/require-auth';
import { LoginPage } from '@/features/auth/login-page';
import { OverviewPage } from '@/features/overview/overview-page';
import { HotelsPage } from '@/features/hotels/hotels-page';
import { HotelPage } from '@/features/hotels/hotel-page';
import { UsersPage } from '@/features/users/users-page';
import { OrganizationsPage } from '@/features/organizations/organizations-page';
import { OrganizationPage } from '@/features/organizations/organization-page';
import { PlansPage } from '@/features/plans/plans-page';
import { SubscriptionsPage } from '@/features/subscriptions/subscriptions-page';
import { ChannexPage } from '@/features/channex/channex-page';
import { ChannexIntegrationPage } from '@/features/channex/channex-integration-page';
import { AccountPage } from '@/features/account/account-page';
import { EmailTemplatesPage } from '@/features/email-templates/email-templates-page';
import { EmailTemplatePage } from '@/features/email-templates/email-template-page';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: <RequireAuth />,
    children: [
      { path: '/', element: <OverviewPage /> },
      { path: '/organizations', element: <OrganizationsPage /> },
      { path: '/organizations/:id', element: <OrganizationPage /> },
      { path: '/hotels', element: <HotelsPage /> },
      { path: '/hotels/:id', element: <HotelPage /> },
      { path: '/users', element: <UsersPage /> },
      { path: '/plans', element: <PlansPage /> },
      { path: '/subscriptions', element: <SubscriptionsPage /> },
      { path: '/channex-cost', element: <ChannexPage /> },
      { path: '/channex', element: <ChannexIntegrationPage /> },
      { path: '/email-templates', element: <EmailTemplatesPage /> },
      { path: '/email-templates/:kind', element: <EmailTemplatePage /> },
      { path: '/account', element: <AccountPage /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
